class VwHbsHastarecete2DTO {
    id: number = null;
    receteId?: number = null;
    aciklama?: string = "";
    adi?: string = "";
    adet?: number = null;
    ambalajadet?: number = null;
    kullanimperiyod?: number = null;
    ilactanimId?: number = null;
    fkPeriyodbirim?: number = null;
    fkKullanimsekli?: number = null;
    barkodNo?: string = "";
    fkKullanimdoz?: number = null;
    kullanimdoz1?: number = null;
    kullanimdoz2?: number = null;
    geriodemekapsam?: string = "H";
    rapordurum?: number = null;
    actok?: string = "";
    ecziptal?: string = "H";
    fkEcziptalneden?: number = null;
    humanalbuminend?: string = "";
    humanalbuminendaciklama?: string = "";
    ekleyenKullanici?: number = null;
    eklemeTarihi?: string = null;
    iptal?: string = "H";
    iptalKullanici?: number = null;
    iptalTarihi?: string = null;
    peryod?: string = null;
    kullanimSekli?: string = null;
}
export default VwHbsHastarecete2DTO;